import client from "../client";

export default function API(): Promise<number> {
  return client
    .get(`commission/get_count_amount_member`)
    .then((response) => response.data);
}
